import { AileronFormElementDirective } from '@shared/directives/aileron-form-element.directive';
import { CUSTOM_ELEMENTS_SCHEMA, Injector, NgModule } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { CoreModule } from '@core/core.module';
import { FlightStatusRoutingModule } from '@modules/flight-status/flight-status-routing.module';
import { FlightStatusComponent } from '@modules/flight-status/flight-status.component';
import { FlightStatusDateService } from './flight-status-date.service';
import { HttpClientModule } from '@angular/common/http';
import { CitiesComponent } from './cities/cities.component';
import { FlightNumberComponent } from './flight-number/flight-number.component'
import { DataCollectionClientService } from '@core/services/data-collection-client.service';
import '@aileron/button';
import '@aileron/button-icon';
import '@aileron/content-switcher';
import '@aileron/grid';
import '@aileron/icon';
import '@aileron/link';
import '@aileron/loading';
import '@aileron/notification';
import '@aileron/select';
import '@aileron/text-input';
import '@aileron-web/auto-complete';
import { DataCollectionService } from '@aileron/components';
import { NearestAirportService } from '@modules/flight-status/cities/nearest-airport.service';

@NgModule({
    declarations: [
        FlightStatusComponent,
        AileronFormElementDirective,
        CitiesComponent,
        FlightNumberComponent
    ],
    imports: [
        CoreModule,
        FlightStatusRoutingModule,
        HttpClientModule
    ],
    exports: [
        FlightStatusComponent
    ],
    providers: [
        FlightStatusDateService,
        DataCollectionService,
        DataCollectionClientService,
        NearestAirportService
    ],
    entryComponents: [FlightStatusComponent],
    schemas:[CUSTOM_ELEMENTS_SCHEMA]
})
export class FlightStatusModule {
    constructor(private injector: Injector) {
        const flightStatusComponent = createCustomElement(FlightStatusComponent, { injector });
        customElements.define('hp-flight-status', flightStatusComponent);
    }
}
